import { Observable } from 'rxjs/Observable';



import { MatDialog } from '@angular/material/dialog';
import { ListUsers } from './../../../model/usuario/list-user-alfresco.module';
import { EntryUser } from './../../../model/usuario/entry-alfresco.module';
import { EntryUserObject } from './../../../model/usuario/entry-user-alfresco-object.module';
import { UsuarioModelAlfresco } from './../../../model/usuario/usuario-alfresco.model';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '@alfresco/adf-core';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { RoleModel } from './../../../model/usuario/role.model';
import { UsuarioModel } from './../../../model/usuario/usuario.model';
import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { AfterViewInit, Component, OnChanges, OnInit, ViewChild, SimpleChanges } from '@angular/core';
import { MatSort, MatTableDataSource} from '@angular/material';
import {MatPaginator} from '@angular/material';
import { VincularEmpresaDialogComponent } from 'app/components/vincular-empresa-dialog/vincular-empresa-dialog.component';

let ELEMENT_DATA: EntryUser[] = [];

let registrosDatabase : any ;

@Component({
  selector: 'app-permissao',
  templateUrl: './permissao.component.html',
  styleUrls: ['./permissao.component.scss']
})
export class PermissaoComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  contador = 1;
  // Usuários listados na tela inicial
  usuario = {} as UsuarioModel;
  usuarios: Array<EntryUser>;
  // RoleModel usado na listagem das roles por Usuario
  role = {} as RoleModel;
  roles: RoleModel[] = new Array();
  // Usuários listados de acordo com o grupo que faz parte
  usuariorole = {} as UsuarioModel;
  usuarioroles: UsuarioModel[];
  // RoleModel usado na listagem de todos os Grupos
  totalrole = {} as RoleModel;
  totalroles: RoleModel[];
  // Usuários listados para adicionar a um grupo
  adicionarusuario = {} as UsuarioModel;
  adicionarusuarios: UsuarioModel[];


  roleExcluir = {} as RoleModel;
  queryField = new FormControl();
  nameRoles: any[] = [];

  listausuarios = false;
  page: ResponsePageable;
  deleteSuccess = false;
  postSuccess = false;
  loading = false;
  busca = false;
  qtdUsersEncontrados = 0;

  erro403 = false;

  constructor(private permissoesService: PermissoesService,
    private authService: AuthenticationService,
    private router: Router,
    public dialog: MatDialog) {

      this.permissoesService.getUsuarios().subscribe( data => {
        let teste : EntryUser[] = [];
        data.list.entries.forEach(element => {
          teste.push(element.entry)
        });
        this.dataSource = new MatTableDataSource(teste);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });

    }

  ngOnInit() {

  }

  openDialog(usuario) {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + 'px';
    } else {
      largura = innerWidth - innerWidth / 2 + 'px';
    }
    const dialogRef = this.dialog.open(VincularEmpresaDialogComponent, {
      data: { dataDialog: usuario },
      width: largura
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });


  }

  applyFilter(filterValue: string) {


    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;


  }
  rowClicked(row: any): void {
    console.log(row);
    console.log(this.dataSource)
  }

  private listaUsuarios() {
    this.permissoesService.getUsuarios().subscribe( data => {

      console.log(data.list);

    }, err => {
      console.error(err.error.status);
      if (err.error.status === 403 || err.error.status === 401) {
        this.erro403 = true;
      }
    console.log(err);
    });
  }

  listRolesUsuarios(id: number) {
    this.permissoesService.getRolesUsuario(id).subscribe(data => {
      this.roles = data;
    }, err => {
      console.error(err);
    });
  }

  listarRoles() {
    this.permissoesService.getRoles().subscribe(data => {
      this.totalroles = data;
    }, err => {
      console.error(err);
    });
  }

  getRoleAtual(role: RoleModel) {
    this.roleExcluir = { ...role};
  }

  buscaUsuario(nome: String) {
    this.permissoesService.searchUsuario(nome).subscribe( data => {
      this.adicionarusuarios = data;
      this.qtdUsersEncontrados = data.length;
    }, err => {
      console.error(err);
    });
  }

  onSearch() {
    this.busca = true;
    if (this.queryField.value === '') {
      this.buscaUsuario(this.queryField.value);
    } else {
      this.buscaUsuario(this.queryField.value);
    }
  }

  displayedColumns = ['id', 'displayName', 'enabled', 'email', 'acoes'];
  dataSource: MatTableDataSource<EntryUser>;
}



// WEBPACK FOOTER //
// /app/src/app/components/usuario/permissao/permissao.component.ts